import { useEffect, useState, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import Header from "../Header";
import http from "../../api/server";
import { useSelector } from "react-redux";
import Toaster from "./Toaster";
import { GET_DOOR_INSPECTION_DATA } from "../../api/apiPath";
import { useNavigate, generatePath, useParams } from "react-router-dom";
import { UserRoles } from "./constant";
const QrScanner = ({ renderInComponent = false }) => {
  const { userObj } = useSelector((state) => state.user);
  const { clientNameParam } = useParams();
  const [cameras, setCameras] = useState([]);
  const [selectedCameraId, setSelectedCameraId] = useState(null);
  const [isScanning, setIsScanning] = useState(false);
  const html5QrCodeRef = useRef(null);
  const [scannedLink, setScannedLink] = useState(null);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const [hideSidebar, setHideSidebar] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    // setIsScanning(true);

    Html5Qrcode.getCameras()
      .then((devices) => {
        setCameras(devices);
        if (devices.length > 0) setSelectedCameraId(devices[0].id);
        //startScanning();
      })
      .catch((err) => console.error("Camera Error:", err));
  }, []);

  const [toastData, setToastData] = useState({
      toastShow: false,
      toastType: "",
      toastString: "",
    });
    const closeButton = () => {
      setToastData({
        toastShow: false,
        toastData: "",
        toastType: "",
      });
    };

  useEffect(() => {
    if (selectedCameraId && !isScanning) {
      startScanning();
    }
    // eslint-disable-next-line
  }, [selectedCameraId]);
  useEffect(() => {
    return () => {
      if (html5QrCodeRef?.current?.isScanning) {
        html5QrCodeRef.current
          .stop()
          .then(() => html5QrCodeRef.current.clear())
          .catch(() => {});
      }
    };
  }, []);

  const startScanning = () => {
    setIsScanning(true);
    if (!selectedCameraId) return;

    html5QrCodeRef.current = new Html5Qrcode("reader");

    html5QrCodeRef.current
      .start(
        selectedCameraId, // ✅ Only pass the camera ID here
        {
          fps: 10,
          qrbox: { width: 250, height: 250 },
        },
        (decodedText) => {
          //let url = decodedText.trim();
          // if (!url.startsWith("http://") && !url.startsWith("https://")) {
          //   url = "https://" + url; // Prepend https if missing
          // }
          console.log("Decoded Text:", decodedText);
          setScannedLink(decodedText);
          const hasEditLink = decodedText.toLowerCase().includes("/editsurvey");
          if (hasEditLink) {
            handleCheckEditSurvey(decodedText);
            // window.open(decodedText, "_blank");
          } else {
            window.open(decodedText, "_blank");
          }
          setIsScanning(true);
          stopScanning();
        },
        // (errorMessage) => {
        //   console.warn("Scan error:", errorMessage);
        // }
      )
      .catch((err) => console.error("Start Scan Error:", err));
  };

  const parseSurveyPath = (pathname) => {
    // Normalize and ensure we look after "/viewSurvey/"
    const marker = "/editSurvey/";
    const idx = pathname.toLowerCase().indexOf(marker.toLowerCase());
    if (idx === -1) return null;

    // Take everything after /viewSurvey/
    const rest = pathname.slice(idx + marker.length);

    // In case there are query strings or hashes (rare for path usage)
    const cleaned = rest.split(/[?#]/)[0];

    // Now split into segments
    const [propertyMasterId, inspectionRefNo, doorNumber] = cleaned.split("/");

    if (!propertyMasterId || !inspectionRefNo || !doorNumber) return null;

    return { propertyMasterId, inspectionRefNo, doorNumber };
  };

  const handleCheckEditSurvey = async (url) => {
    const params = parseSurveyPath(url);
    try {
      const doorData = await http.get(
        GET_DOOR_INSPECTION_DATA +
          params?.doorNumber +
          "&propertyMasterId=" +
          params?.propertyMasterId +
          "&inspectionRefNumber=" +
          params?.inspectionRefNo,
      );
      if (doorData?.status === 200) {
        gotoEditSurvey(url);
      }
    } catch (err) {
      if (err.status === 404) {
        if(userObj?.isAdmin || userObj?.roleId === UserRoles.INSPECTOR){
          gotoDashBoardMapped(url);
        }else{
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString:
              "The survey linked to this QR code has not been submitted yet. Please contact the inspector for more details.",
          });
        }
      }
    }
  };

  const gotoDashBoardMapped = ( mappedUrl) => {
    const urlTouse = mappedUrl.split("Survey/")[1];
    const pathTemplate = `/client/:clientNameParam/dashboard/${urlTouse}`;
    const params = {
      clientNameParam: clientNameParam,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const gotoEditSurvey = (mappedUrl) => {
    const urlTouse = mappedUrl.split("Survey/")[1];
    const pathTemplate = `/client/:clientNameParam/editSurvey/${urlTouse}`;
    const params = {
      clientNameParam: clientNameParam,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const stopScanning = () => {
    setIsScanning(false);
    if (html5QrCodeRef?.current?.isScanning) {
      html5QrCodeRef.current
        .stop()
        .then(() => html5QrCodeRef.current.clear())
        .catch((err) => console.error("Stop Scan Error:", err));
    }
  };

  // const scanImageFile = (event) => {
  //   const file = event.target.files[0];
  //   if (file && html5QrCodeRef.current) {
  //     html5QrCodeRef.current
  //       .scanFile(file, true)
  //       .then(decodedText => setScannedText(decodedText))
  //       .catch(err => console.error("Image Scan Error:", err));
  //   }
  // };
  const handleChange = (e) => {
    stopScanning();
    setSelectedCameraId(e.target.value);
  };
  const handleBack = () => {
    // navigate(
    //   generatePath("/client/:clientNameParam/property-form", {
    //     clientNameParam,
    //   }),
    // );
    navigate(-1);
  };
  return (
    <>
      <div>
        {renderInComponent ? null : (
          <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
        )}
      </div>
      <div
        className={`${
          renderInComponent ? "render-scanner" : "no-render-scanner mb-3"
        } mx-auto`}
      >
        <div className="form-floating mb-3">
          <select
            className="form-select"
            name="doorType"
            id="floatingSelect"
            aria-label="Floating label select example"
            value={selectedCameraId || ""}
            onChange={handleChange}
          >
            {cameras.map((cam) => (
              <option key={cam.id} value={cam.id}>
                {cam.label}
              </option>
            ))}
          </select>
          <label htmlFor="floatingSelect">Camera</label>
        </div>

        <div id="reader" style={{ width: "100%", margin: "20px auto" }} />

        <div className="d-flex gap-3">
          {isScanning == false && (
            <button
              className="btn btn-secondary flex-fill"
              type="button"
              onClick={startScanning}
            >
              Start Scanning
            </button>
          )}

          {isScanning == true && (
            <button
              className="btn btn-secondary flex-fill"
              type="button"
              onClick={stopScanning}
            >
              Stop Scanning
            </button>
          )}
          {isSafari && scannedLink && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => window.open(scannedLink, "_blank")}
            >
              Open Scanned Link
            </button>
          )}
          {!renderInComponent && (
            <button
              type="button"
              className="btn btn-secondary flex-fill"
              onClick={() => {
                handleBack();
              }}
            >
              Back
            </button>
          )}
        </div>
        <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={() => {
              closeButton();
            }}
          />
      </div>
    </>
  );
};

export default QrScanner;
